module.exports = __webpack_public_path__ + "img/arrows-left-right.44c84c2b.svg";